// ============================================================
// Group Buy Flats – Central Data Store
// NOTE: In production, replace localStorage with PostgreSQL API calls
// Table structures documented at bottom of this file
// ============================================================
import heroVideo from "../assets/home.mp4";
import heroImg1 from "../assets/logos/Image10.png";
import heroImg2 from "../assets/Image4.png";
import heroImg3 from "../assets/Image 9.png";
import heroImg4 from "../assets/logos/img4.jpeg";
import heroImg5 from "../assets/logos/img5.png";


export const CONTACT_PHONE = "9709704567";
export const CONTACT_WHATSAPP = `https://wa.me/91${CONTACT_PHONE}`;
export const CONTACT_EMAIL = "connect@groupbuyflats.com";
export const COMPANY_ADDRESS = "Groupbuy Flats, Banjara Hills, Hyderabad 500028";

// ─── PROPERTIES ─────────────────────────────────────────────
export const PROPERTIES = [
  {
    id: "prop_001",
    title: "Vertex Heights",
    builder: "Vertex",
    type: "Apartment",
    area: "Gachibowli",
    city: "Hyderabad",
    price: "₹85L – ₹1.2Cr",
    bhk: "2 BHK / 3 BHK",
    status: "Ready to Move",
    description:
      "Premium luxury apartments in Gachibowli with world-class amenities, landscaped gardens, and stunning city views. Built by Vertex, one of Hyderabad's most trusted builders.",
    highlights: ["Swimming Pool", "24/7 Security", "Clubhouse", "Power Backup", "EV Charging"],
    images: [
      "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1200&q=80",
      "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=1200&q=80",
      "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=1200&q=80",
    ],
    video: null,
    brochure: "/brochures/vertex-heights.pdf",
    lat: 17.4401,
    lng: 78.3489,
    featured: true,
  },
  {
    id: "prop_002",
    title: "Lansom Villas",
    builder: "Lansom",
    type: "Villa",
    area: "Kokapet",
    city: "Hyderabad",
    price: "₹2.5Cr – ₹3.8Cr",
    bhk: "4 BHK",
    status: "Under Construction",
    description:
      "Exclusive ultra-luxury villas at Kokapet with private pools, smart home systems, and panoramic views. Lansom's flagship project designed for discerning buyers.",
    highlights: ["Private Pool", "Smart Home", "3-car Parking", "Gym", "Landscaped Garden"],
    images: [
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=1200&q=80",
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&q=80",
      "https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=1200&q=80",
    ],
    video: null,
    brochure: "/brochures/lansom-villas.pdf",
    lat: 17.4156,
    lng: 78.3272,
    featured: true,
  },
  {
    id: "prop_003",
    title: "Kakatiya Residences",
    builder: "Kakatiya Developers",
    type: "Apartment",
    area: "Kondapur",
    city: "Hyderabad",
    price: "₹65L – ₹90L",
    bhk: "2 BHK / 3 BHK",
    status: "Ready to Move",
    description:
      "Contemporary residences in the heart of Kondapur, offering excellent connectivity to HITEC City and surrounded by top schools and hospitals.",
    highlights: ["Clubhouse", "Children's Play Area", "Jogging Track", "24/7 Security"],
    images: [
      "https://images.unsplash.com/photo-1486325212027-8081e485255e?w=1200&q=80",
      "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=1200&q=80",
      "https://images.unsplash.com/photo-1524758631624-e2822e304c36?w=1200&q=80",
    ],
    video: null,
    brochure: null,
    lat: 17.4625,
    lng: 78.3645,
    featured: false,
  },
  {
    id: "prop_004",
    title: "Greenfield Plots",
    builder: "Greenfield Estates",
    type: "Plot",
    area: "Shamshabad",
    city: "Hyderabad",
    price: "₹40L – ₹1.2Cr",
    bhk: "150 – 500 sq yd",
    status: "Available",
    description:
      "HMDA-approved premium plots near the airport corridor. Ideal for custom villa construction with excellent appreciation potential.",
    highlights: ["HMDA Approved", "24/7 Security", "Wide Roads", "Underground Utilities"],
    images: [
      "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=1200&q=80",
      "https://images.unsplash.com/photo-1416331108676-a22ccb276e35?w=1200&q=80",
    ],
    video: null,
    brochure: null,
    lat: 17.2403,
    lng: 78.4294,
    featured: false,
  },
  {
    id: "prop_005",
    title: "Vertex Horizon",
    builder: "Vertex",
    type: "Apartment",
    area: "Narsingi",
    city: "Hyderabad",
    price: "₹1.1Cr – ₹1.8Cr",
    bhk: "3 BHK / 4 BHK",
    status: "Under Construction",
    description:
      "Sky-high residences with floor-to-ceiling windows, private decks, and resort-style amenities in the rapidly growing Narsingi corridor.",
    highlights: ["Infinity Pool", "Sky Lounge", "Business Center", "Spa & Wellness"],
    images: [
      "https://images.unsplash.com/photo-1493809842364-78817add7ffb?w=1200&q=80",
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=1200&q=80",
    ],
    video: null,
    brochure: "/brochures/vertex-horizon.pdf",
    lat: 17.3958,
    lng: 78.3316,
    featured: true,
  },
  {
    id: "prop_006",
    title: "Lansom Meadows",
    builder: "Lansom",
    type: "Villa",
    area: "Tukkuguda",
    city: "Hyderabad",
    price: "₹1.8Cr – ₹2.6Cr",
    bhk: "3 BHK / 4 BHK Villa",
    status: "Available",
    description:
      "Spacious independent villas with private gardens set in a serene gated township. RERA registered with clear legal title.",
    highlights: ["Independent Villa", "Private Garden", "RERA Registered", "Gated Township"],
    images: [
      "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=1200&q=80",
      "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?w=1200&q=80",
    ],
    video: null,
    brochure: null,
    lat: 17.2718,
    lng: 78.5122,
    featured: false,
  },
];

export const PROPERTY_TYPES = ["All", "Apartment", "Villa", "Plot"];
export const PROPERTY_AREAS = ["All", "Gachibowli", "Kokapet", "Kondapur", "Shamshabad", "Narsingi", "Tukkuguda"];
export const BUILDERS = ["All", "Vertex", "Lansom", "Kakatiya Developers", "Greenfield Estates"];

// ─── HERO CAROUSEL ──────────────────────────────────────────
// NOTE: Hero now shows ONLY the brand video — all image slides have
// been removed. The video autoplays muted/looped for background-hero
// behavior. Swap heroVideo's import path above if the asset changes.
export const HERO_SLIDES = [
  {
    id: 1,
    type: "video",
    src: heroVideo,
    cta: "Explore Properties",
    autoPlay: true,
    muted: true,
    loop: true,
  },
];

// ─── FAQ DATA ────────────────────────────────────────────────
export const FAQS = [
  {
    keywords: ["group buy", "how it works", "concept", "what is", "explain"],
    question: "How does GroupBuy Flats work?",
    answer:
      "GroupBuy Flats pools demand from multiple buyers and approaches builders as a group. Instead of one person negotiating, we negotiate as a collective — giving you far better pricing than you could get individually. We handle the entire process from discovery to final paperwork.",
  },
  {
    keywords: ["discount", "how much", "save", "benefit", "price", "deal"],
    question: "How much discount can I get?",
    answer:
      "We don't promise a fixed discount — it depends on the builder, project stage, and group size on the day. What we guarantee is that your group negotiation will always get you a better deal than going alone. We present your collective buying power and get the best price available on that day.",
  },
  {
    keywords: ["kakatiya", "kondapur", "vertex", "lansom", "gachibowli", "kokapet", "narsingi", "property", "project"],
    question: "Which properties are available?",
    answer:
      "We have premium properties across Hyderabad — apartments, villas, and plots in Gachibowli, Kokapet, Kondapur, Narsingi, Shamshabad, and Tukkuguda. Our builder partners include Vertex and Lansom. Type a location or property name and I can tell you more!",
  },
  {
    keywords: ["schedule", "visit", "site", "appointment", "meet"],
    question: "Can I schedule a site visit?",
    answer:
      "Absolutely! Our associates arrange site visits for all interested buyers. After registering your interest, our team will coordinate a convenient time for you to visit the property. Would you like to connect with an associate right now?",
  },
  {
    keywords: ["loan", "bank", "finance", "emi", "home loan"],
    question: "Do you help with home loans?",
    answer:
      "Yes! GroupBuy Flats assists with the entire purchase journey — including connecting you with banking partners for home loans. We can facilitate introductions to leading banks and help with documentation and paperwork.",
  },
  {
    keywords: ["legal", "rera", "title", "registration", "documents", "safe"],
    question: "Are these properties legally clear?",
    answer:
      "We only list RERA-registered projects with clear legal titles. Our team verifies all documentation before listing. We also connect buyers with legal advisors if needed.",
  },
  {
    keywords: ["contact", "call", "speak", "talk", "associate", "agent"],
    question: "How do I reach an associate?",
    answer: `You can call or WhatsApp us at +91 ${CONTACT_PHONE}. Our team is available during business hours (Mon–Sat, 9am–7pm). Click the button below to connect instantly!`,
  },
];

// ─── LEAD STORAGE (localStorage — replace with PostgreSQL API) ──
export const LEAD_CHANNELS = {
  WEB: "Web",
  WHATSAPP: "WhatsApp",
  PHONE: "Phone",
  CHATBOT: "Chatbot",
};

export function saveLeadToStorage(lead) {
  const existing = JSON.parse(localStorage.getItem("gbf_leads") || "[]");
  const newLead = {
    id: `lead_${Date.now()}`,
    createdAt: new Date().toISOString(),
    status: "New",
    ...lead,
  };
  existing.unshift(newLead);
  localStorage.setItem("gbf_leads", JSON.stringify(existing));
  return newLead;
}

export function getLeadsFromStorage() {
  return JSON.parse(localStorage.getItem("gbf_leads") || "[]");
}

export function updateLeadStatus(id, status) {
  const leads = getLeadsFromStorage();
  const updated = leads.map((l) => (l.id === id ? { ...l, status } : l));
  localStorage.setItem("gbf_leads", JSON.stringify(updated));
}

/*
 ═══════════════════════════════════════════════════════════
  POSTGRESQL SCHEMA (for Nagesh — production implementation)
 ═══════════════════════════════════════════════════════════

  TABLE: leads
  ─────────────────────────────────────────────────────────
  id            SERIAL PRIMARY KEY
  first_name    VARCHAR(100) NOT NULL
  last_name     VARCHAR(100)
  phone         VARCHAR(20) NOT NULL
  email         VARCHAR(255)
  channel       VARCHAR(50) NOT NULL  -- 'Web' | 'WhatsApp' | 'Phone' | 'Chatbot'
  property_id   VARCHAR(50)           -- FK → properties.id (nullable)
  message       TEXT
  status        VARCHAR(50) DEFAULT 'New'  -- 'New' | 'Contacted' | 'Qualified' | 'Closed'
  created_at    TIMESTAMPTZ DEFAULT NOW()
  updated_at    TIMESTAMPTZ DEFAULT NOW()

  TABLE: properties
  ─────────────────────────────────────────────────────────
  id            VARCHAR(50) PRIMARY KEY
  title         VARCHAR(255)
  builder       VARCHAR(100)
  type          VARCHAR(50)
  area          VARCHAR(100)
  city          VARCHAR(100)
  price         VARCHAR(100)
  bhk           VARCHAR(100)
  status        VARCHAR(100)
  description   TEXT
  highlights    TEXT[]
  lat           DECIMAL(10,7)
  lng           DECIMAL(10,7)
  brochure_url  VARCHAR(500)
  created_at    TIMESTAMPTZ DEFAULT NOW()

  TABLE: property_media
  ─────────────────────────────────────────────────────────
  id            SERIAL PRIMARY KEY
  property_id   VARCHAR(50) REFERENCES properties(id)
  media_type    VARCHAR(20)   -- 'image' | 'video'
  url           TEXT
  sort_order    INTEGER
  builder       VARCHAR(100)  -- for folder-based Azure Blob organization
  created_at    TIMESTAMPTZ DEFAULT NOW()

  INDEXES: CREATE INDEX ON leads(created_at DESC);
           CREATE INDEX ON leads(channel);
           CREATE INDEX ON leads(property_id);
           CREATE INDEX ON leads(status);
*/